import * as React from "react";
import { useNavigate } from "react-router-dom";
import {atualizarBancos} from "../../../src/Services/index.js";

import {
  Box,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  Container,
  Avatar,
  Tooltip,
  MenuItem,
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ModalNewuser from "../ModalNewUser";
import AddNotification from "../Snackbars";
import ModalAtualizarBanco from "../ModalAtualizarBanco.js";
import ModalAtualizaPNCP from "../ModalAtualizarPNCP/index.js";
import ModalAtualizacaoBancoEmAndamento from "../ModalAtualizacaoBancoEmAndamento/index.js";

const ResponsiveAppBar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [isAdm, setAdm] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [user, setUser] = React.useState("");
  const [notification, setNotification] = React.useState({
    message: "",
    open: false,
    severity: "",
  });
  const [atualizarBanco, setAtualizarBanco] = React.useState(false);
  const [atualizacaoBanco, setAtualizacaoBanco] = React.useState(false);
  const [brasao, setBrasao] = React.useState("");
  const [modalPNCP, setModalPNCP] = React.useState(false);
  const navigate = useNavigate();

  const handleOpenAtualizarBanco = () => setAtualizarBanco(true);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleAtualizarBancos = async () => {
    setAtualizacaoBanco(true)
    const response = await atualizarBancos();
    if (response.status === 200) {
      setNotification({
        message: "Bancos atualizados com sucesso!",
        open: true,
        severity: "success",
      });
    } else {
      setNotification({
        message: "Erro ao atualizar bancos.",
        open: true,
        severity: "error",
      });
    }
    setAtualizacaoBanco(false);
  }


  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/", { replace: true });
  };

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  React.useEffect(() => {
    const admin = sessionStorage.getItem("isAdm") === "true";
    const _user = sessionStorage.getItem("user");
    const brasao = sessionStorage.getItem("brasao");

    setAdm(admin);
    setUser(_user);
    setBrasao(brasao);
  });

  return (
    <AppBar position="static">
  <AddNotification
    notification={notification}
    setNotification={setNotification}
  />

  <Container maxWidth="xl" sx={{ py: 0 }}>
    <Toolbar
      disableGutters
      sx={{
        minHeight: "48px !important",
        height: "48px !important",
        px: 1,
      }}
    >
      {/* VOLTAR */}
      <Typography
        variant="body2"
        noWrap
        component="a"
        onClick={() => navigate("/inicio")}
        sx={{
          mr: 2,
          ml: 1,
          display: "flex",
          fontWeight: 500,
          fontSize: "0.8rem",
          letterSpacing: ".05rem",
          color: "inherit",
          textDecoration: "none",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <ArrowBackIcon sx={{ mr: 0.5, fontSize: 18 }} />
        VOLTAR
      </Typography>

      {/* TITULO */}
      <Box sx={{ flexGrow: 1, display: "flex" }}>
        <Typography
          noWrap
          sx={{
            ml: 1,
            fontWeight: 700,
            fontSize: "0.9rem",
            letterSpacing: ".08rem",
            color: "inherit",
            display: { xs: "none", md: "flex" },
            alignItems: "center",
          }}
        >
          PESQUISAS
        </Typography>

        <Typography
          noWrap
          sx={{
            ml: 1,
            fontWeight: 600,
            fontSize: "0.8rem",
            letterSpacing: ".05rem",
            color: "inherit",
            display: { xs: "none", md: "flex" },
            alignItems: "center",
          }}
        >
          &gt; MATERIAIS/SERVIÇOS
        </Typography>
      </Box>

      {/* USUÁRIO */}
      <Stack sx={{ textAlign: "right", mr: 1 }}>
        <Typography
          noWrap
          sx={{
            fontWeight: 600,
            fontSize: "0.65rem", // MENOR QUE TODAS
            opacity: 0.85,
          }}
        >
          Usuário
        </Typography>

        <Typography
          variant="caption"
          noWrap
          sx={{
            fontSize: "0.75rem",
            fontWeight: 500,
            letterSpacing: ".03rem",
          }}
        >
          {user}
        </Typography>
      </Stack>

      {/* FOTO */}
      <Tooltip title="Abrir configurações">
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
          <Avatar
            alt={user.length > 0 ? user : "D"}
            sx={{
              height: 36, // menor avatar
              width: 36,
              fontSize: "0.8rem",
            }}
            imgProps={{ style: { objectFit: "contain" } }}
            src={brasao || "/static/images/avatar/2.jpg"}
          />
        </IconButton>
      </Tooltip>

      {/* MENU */}
      <Menu
        sx={{ mt: "36px" }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {isAdm && (
          <MenuItem onClick={handleOpen}>
            <Typography textAlign="center">Cadastro de clientes</Typography>
          </MenuItem>
        )}

        {isAdm && (
          <MenuItem onClick={handleAtualizarBancos}>
            <Typography textAlign="center">Atualizar Bancos</Typography>
          </MenuItem>
        )}

        <MenuItem onClick={() => setModalPNCP(!modalPNCP)}>
          <Typography textAlign="center">Atualizar PNCP</Typography>
        </MenuItem>

        <MenuItem onClick={handleLogout}>
          <Typography textAlign="center">Sair</Typography>
        </MenuItem>
      </Menu>
    </Toolbar>
  </Container>

  {/* MODAIS */}
  <ModalNewuser
    adm={isAdm}
    open={open}
    onClose={handleClose}
    setNotification={setNotification}
  />

  <ModalAtualizacaoBancoEmAndamento
    open={atualizacaoBanco}
    onClose={() => setAtualizacaoBanco(false)}
  />

  <ModalAtualizarBanco
    adm={isAdm}
    open={atualizarBanco}
    onClose={() => setAtualizarBanco(false)}
    setNotification={setNotification}
  />

  <ModalAtualizaPNCP
    open={modalPNCP}
    onClose={() => setModalPNCP(false)}
    setNotification={setNotification}
  />
</AppBar>
  );
};
export default ResponsiveAppBar;
